/**
 * Helpers DOM sécurisés pour éviter NotFoundError: removeChild, etc.
 * À utiliser UNIQUEMENT pour manipuler le DOM dans portails/overlays, jamais sur des noeuds gérés par React.
 */

export function safeRemoveNode(node) {
  try {
    if (!node || !(node instanceof Node)) return;
    
    // 🔥 FIX: Utiliser node.remove() en priorité (plus robuste)
    if (typeof node.remove === 'function') {
      try {
        node.remove();
        return;
      } catch (e) {
        // Si remove() échoue, fallback sur removeChild
        console.warn('node.remove() failed, trying removeChild:', e?.message);
      }
    }
    
    // Fallback: vérifier que le node a bien un parent avant removeChild
    const parent = node.parentNode;
    if (!parent) {
      // Le node n'a déjà plus de parent, rien à faire
      return;
    }
    
    // Double vérification avec contains() pour éviter NotFoundError
    if (parent.contains(node)) {
      try {
        parent.removeChild(node);
      } catch (err) {
        // Si removeChild échoue, c'est que le node n'est plus enfant (race condition)
        // C'est acceptable, on ignore silencieusement
        console.warn('safeRemoveNode: node already removed:', err?.message);
      }
    }
  } catch (err) {
    // Ne jamais crasher l'app pour un cleanup tardif
    console.warn('safeRemoveNode failed:', err?.message);
  }
}

export function safeAppend(parent, child) {
  try {
    if (!parent || !child) return;
    if (!parent.contains(child)) parent.appendChild(child);
  } catch (err) {
    console.warn('safeAppend failed:', err?.message);
  }
}

/**
 * Conteneur de portail stable et global. Ne pas le supprimer (on peut vider ses enfants).
 * Place en haut de la pile pour overlays/toasts.
 */
export function ensurePortalRoot(id = 'cc-portal-root') {
  try {
    if (typeof document === 'undefined') return null;
    let el = document.getElementById(id);
    if (el) return el;

    el = document.createElement('div');
    el.id = id;
    el.setAttribute('data-portal', 'cabconnect');
    // style non intrusif
    el.style.position = 'fixed';
    el.style.inset = '0';
    el.style.pointerEvents = 'none';
    el.style.zIndex = '9999';
    document.body.appendChild(el);
    return el;
  } catch (err) {
    console.warn('ensurePortalRoot failed:', err?.message);
    return null; // fallback non bloquant
  }
}

/** Vide les enfants du conteneur (mais on NE supprime PAS le conteneur) */
export function clearPortalRoot(id = 'cc-portal-root') {
  try {
    const root = document.getElementById(id);
    if (!root) return;
    // Nettoyage sûr: on retire chaque enfant, idempotent
    Array.from(root.childNodes).forEach(safeRemoveNode);
  } catch (err) {
    console.warn('clearPortalRoot failed:', err?.message);
  }
}

// (facultatif mais utile pour interop)
const SafeDom = { safeRemoveNode, safeAppend, ensurePortalRoot, clearPortalRoot };
export default SafeDom;